import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import {useStyles} from "../ArticleDelivery.style";
import clsx from "clsx";
import ArticleDeliveryRowProperties from "./ArticleDeliveryRowProperties";
import ShowDate from "../../../shared_components/Info/ShowDate/ShowDate";
import ShowText from '../../../shared_components/Info/ShowText/ShowText';
import ButtonSize from '../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../ui_components/Button/ButtonType';
import ViewInvoiceButton from "../../../shared_components/Buttons/ViewInvoiceButton/ViewInvoiceButton";
import ShowOrderNumber from '../../../shared_components/Info/ShowOrderNumber/ShowOrderNumber';
import {useUserContext} from '../../../contexts/UserContext';
import AllowAccess from '../../../shared_components/Access/AllowAccess/AllowAccess';
import ExpandoMenu from '../../../ui_components/ExpandoMenu/ExpandoMenu';
import CommentsButton from '../../../shared_components/Buttons/CommentsButton/CommentsButton';
import Checkbox from '../../../ui_components/Checkbox/Checkbox';
import ShowPhoneNumber from '../../../shared_components/Info/ShowPhoneNumber/ShowPhoneNumber';
import PrintToDeliverButton from '../../../shared_components/Buttons/PrintToDeliverButton/PrintToDeliverButton';
import ShowOrderStatus from '../../../shared_components/Info/ShowOrderStatus/ShowOrderStatus';
import UpdateDeliveryOrderStatusButton from '../../../shared_components/Buttons/UpdateDeliveryOrderStatusButton/UpdateDeliveryOrderStatusButton';
import ShowArticleDeliveryArticles from '../../../shared_components/Info/ShowArticleDeliveryArticles/ShowArticleDeliveryArticles';
import DeliveryOrderType from '../../../model/DeliveryOrderType';
import RemoveArticleDeliveryButton from '../../../shared_components/Buttons/RemoveArticleDeliveryButton/RemoveArticleDeliveryButton';
import ObservationsButton from '../../../shared_components/Buttons/ObservationsButton/ObservationsButton';
import ProductOrderStatus from '../../../entities/productOrder/ProductOrderStatus';
import ProductOrderTimelineButton from '../../../shared_components/Buttons/ProductOrderTimelineButton/ProductOrderTimelineButton';
import ServiceName from '../../../entities/ServiceName';
import ContactDetailsButton from '../../../shared_components/Buttons/ContactDetailsButton/ContactDetailsButton';
import Access from '../../../shared_components/Access/AllowAccess/Access';
import ClientOrderReceiptsButton from '../../../shared_components/Buttons/ClientOrderReceiptsButton/ClientOrderReceiptsButton';
import ChooseDeliveryFlowLink from '../../../shared_components/Info/ChooseDeliveryFlowLink/ChooseDeliveryFlowLink';
import AttachmentsButton from '../../../shared_components/Buttons/AttachmentsButton/AttachmentsButton';

const ArticleDeliveryRowMedium: React.FC<ArticleDeliveryRowProperties> = ({
                                                                          articleDeliveryOrder,
                                                                          selectedDeliveryOrderIds,
                                                                          onArticleDeliveryOrderClick,
                                                                          onArticleDeliveryOrderSelect,
                                                                          onDeliveryFlowSelect,
                                                                          onContactSelect,
                                                                          onUpdate,
                                                                          filter,
                                                                          from,
                                                                          to
                                                                      }) => {


    const classes = useStyles();
    const i18n = useI18nContext();
    const userStore = useUserContext();

    const showDeliveryPersonName = userStore.hasAccess(Access.DISPLAY_DELIVERY_PERSON_IN_ORDERS);

    const onRowArticleRemittanceClick = () => {
        onArticleDeliveryOrderClick(articleDeliveryOrder.id);
    }

    const onArticleDeliverySelect = () => {
        onArticleDeliveryOrderSelect(articleDeliveryOrder.id);
    }

    return (
        <div
            className={clsx(
                classes.article_info_container,
                userStore.isRootAgency() || showDeliveryPersonName ? classes.article_info_container_grid_template_big : classes.article_info_container_grid_template_small)}>
            <div>
                <div className={classes.order_number_container}>
                    <Checkbox text={''} onChange={onArticleDeliverySelect}
                              selected={selectedDeliveryOrderIds.findIndex(t => t === articleDeliveryOrder.id) >= 0}/>
                    <ShowOrderNumber orderNumber={articleDeliveryOrder.orderNumber}
                                     className={classes.order_number_text} textToHighlight={filter}/>
                </div>
                <ShowDate label={i18n.translate("CREATED")} timestamp={articleDeliveryOrder.createdAt}
                          className={classes.margin_top_4}/>
                <div className={classes.observation_link_container}>
                    {articleDeliveryOrder.observations &&
                        <ObservationsButton
                            size={ButtonSize.SMALL}
                            deliveryOrderId={articleDeliveryOrder.id}
                            deliveryOrderNumber={articleDeliveryOrder.orderNumber}
                            deliveryOrderObservations={articleDeliveryOrder.observations}
                            isLinkText
                            showText
                            type={ButtonType.SECONDARY}
                            showObservationsTooltip={true}
                        />}
                    {articleDeliveryOrder.comments.length > 0 && 
                        <CommentsButton
                            size={ButtonSize.SMALL}
                            deliveryOrderId={articleDeliveryOrder.id}
                            deliveryOrderNumber={articleDeliveryOrder.orderNumber}
                            isLinkText
                            showText
                            type={ButtonType.SECONDARY}
                        />}
                    {articleDeliveryOrder.attachments.length > 0 && 
                        <AttachmentsButton
                            size={ButtonSize.SMALL}
                            deliveryOrderId={articleDeliveryOrder.id}
                            deliveryOrderNumber={articleDeliveryOrder.orderNumber}
                            attachments={articleDeliveryOrder.attachments}
                            isLinkText
                            showText
                            type={ButtonType.SECONDARY}
                        />}
                </div>
            </div>
            <div>
                <div className={classes.padding_right_5px}>
                    <ShowText text={articleDeliveryOrder.clientName} title={'Remitente'} textToHighlight={filter}/>
                    <div className={classes.client_receipt_btn}>
                        <ClientOrderReceiptsButton showText={false}
                            onlyIcon={true} from={from} to={to} clientId={articleDeliveryOrder.clientId} clientName={articleDeliveryOrder.clientName}/>
                    </div>
                    {articleDeliveryOrder.clientPhone &&
                        <ShowPhoneNumber value={articleDeliveryOrder.clientPhone} showFlag={false} textToHighlight={filter}/>}
                </div>
                <div className={classes.padding_right_5px}>
                    <ShowText text={articleDeliveryOrder.contactName} title={'Destinatario'} textToHighlight={filter}/>
                    <div className={classes.contact_number_container}>
                        {articleDeliveryOrder.contactPhone &&
                            <ShowPhoneNumber value={articleDeliveryOrder.contactPhone} showFlag={false} textToHighlight={filter}/>}
                        <ContactDetailsButton
                            clientId={articleDeliveryOrder.clientId}
                            contactId={articleDeliveryOrder.contactId}
                            showText={false}
                            onlyIcon={true}
                        />
                    </div>
                </div>
            </div>
            <div>
                {articleDeliveryOrder &&
                    <div><small>Entrega</small>
                        <div><ShowText text={articleDeliveryOrder.address}
                                       title={articleDeliveryOrder.geo.name + '. ' + articleDeliveryOrder.geo.parentInfo}/>
                        </div>
                    </div>}
            </div>
            <ShowArticleDeliveryArticles valueToPay={articleDeliveryOrder.totalToPay} articles={articleDeliveryOrder.articles}/>
            <AllowAccess any={[Access.DISPLAY_DELIVERY_PERSON_IN_ORDERS,Access.SET_MONEY_DELIVERY_DELIVERY_PERSON]}>
                    <div className={classes.delivery_flow_container}>
                        <ChooseDeliveryFlowLink
                            articleDeliveryId={articleDeliveryOrder.id}
                            articleDeliveryStatus={articleDeliveryOrder.status}
                            deliveryFlow={articleDeliveryOrder.deliveryFlow}
                            warehouseStep={articleDeliveryOrder.warehouseStep}
                            orderByGeosIdProximity={[articleDeliveryOrder.geo.id]}
                            haveDeliveryPersonSelected={articleDeliveryOrder.deliveryPersonId != null}
                            onClick={onRowArticleRemittanceClick}
                            onSelect={onDeliveryFlowSelect}
                            onClose={onUpdate}
                            readOnly={
                                articleDeliveryOrder.status === 'DELIVERED' ||
                                articleDeliveryOrder.status === 'CANCELED' ||
                                articleDeliveryOrder.status === 'NOT_DELIVERED' ||
                                articleDeliveryOrder.status === 'PROCESSING'
                            }
                        />
                    </div>
            </AllowAccess>
            <div>
                <ShowText text={articleDeliveryOrder.agencyName} title={'Agencia'}/>
                <ShowText text={articleDeliveryOrder.userName} title={'Vendedor'} className={classes.margin_top_8}/>
            </div>
            <div className={classes.status_container}>
                <ShowOrderStatus status={articleDeliveryOrder.status}/>
                {articleDeliveryOrder.status !== ProductOrderStatus.DELIVERED &&
                    articleDeliveryOrder.status !== ProductOrderStatus.CANCELED &&
                    <UpdateDeliveryOrderStatusButton onSave={onUpdate} productOrderId={articleDeliveryOrder.id} deliveryOrderType={DeliveryOrderType.ARTICLE_DELIVERY}/>}
                {articleDeliveryOrder.status === ProductOrderStatus.DELIVERED &&
                    <ProductOrderTimelineButton
                        detailsLink
                        productOrderId={articleDeliveryOrder.id}
                    />}
            </div>
            
            <ExpandoMenu>
                <>
                    <ViewInvoiceButton
                        size={ButtonSize.SMALL}
                        productOrderId={articleDeliveryOrder.id}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                    <PrintToDeliverButton
                        size={ButtonSize.SMALL}
                        productOrderIds={[articleDeliveryOrder.id]}
                        service={ServiceName.ARTICLE_DELIVERY}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                    <ProductOrderTimelineButton
                        size={ButtonSize.SMALL}
                        productOrderId={articleDeliveryOrder.id}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                    <ObservationsButton
                        size={ButtonSize.SMALL}
                        deliveryOrderId={articleDeliveryOrder.id}
                        deliveryOrderNumber={articleDeliveryOrder.orderNumber}
                        deliveryOrderObservations={articleDeliveryOrder.observations}
                        showText
                        type={ButtonType.SECONDARY}
                        onUpdate={onUpdate}
                    />
                    <CommentsButton
                        size={ButtonSize.SMALL}
                        deliveryOrderId={articleDeliveryOrder.id}
                        deliveryOrderNumber={articleDeliveryOrder.orderNumber}
                        showText
                        type={ButtonType.SECONDARY}
                        onClose={onUpdate}
                    />
                    <AttachmentsButton
                        size={ButtonSize.SMALL}
                        deliveryOrderId={articleDeliveryOrder.id}
                        deliveryOrderNumber={articleDeliveryOrder.orderNumber}
                        attachments={articleDeliveryOrder.attachments}
                        showText
                        type={ButtonType.SECONDARY}
                        onClose={onUpdate}
                    />
                    <RemoveArticleDeliveryButton
                        size={ButtonSize.SMALL}
                        onSave={onUpdate}
                        articleDeliveryOrderId={articleDeliveryOrder.id}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                </>
            </ExpandoMenu>
        </div>
    )
}

export default ArticleDeliveryRowMedium;
